export default __webpack_public_path__ + "static/media/word-icon.9cb89467.png";